import { ALL_VISIT_COUNTS } from '@/pages/AllVisitsPage/AllVisits.gql';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { VisitRequestWorkflowStep } from 'gql-types';

import { DialogType, useDialog } from '../../../dialogs/DialogManager';
import { errorToast } from '../../../toast';
import { getBulkTableQueryForWorkflowStep } from './constants';

export const useCancelVisitRequest = ({
    visitRequestId,
    workflowStep,
}: {
    visitRequestId: string;
    workflowStep?: VisitRequestWorkflowStep | null;
}) => {
    const { openDialog } = useDialog();
    const tableQuery = getBulkTableQueryForWorkflowStep(workflowStep);

    // Mutations.
    const [doCancelVisitRequestMutation, { loading, error }] = useMutation(
        CANCEL_VISIT_REQUEST_MUTATION,
        {
            variables: { visitRequestId },
            onError: (error) => {
                if (error instanceof Error) {
                    errorToast(error.message);
                }
            },
            refetchQueries: tableQuery ? [ALL_VISIT_COUNTS, tableQuery] : [ALL_VISIT_COUNTS],
        },
    );

    function confirmCancelVisitRequest() {
        openDialog(DialogType.Confirm, {
            dataTestId: 'confirm-cancel-visit-request-dialog',
            title: 'Cancel Visit Request',
            message: 'Are you sure you want to cancel this visit request?',
            confirmCta: 'Cancel',
            cancelCta: 'Back',
            onConfirm: () => {
                void doCancelVisitRequestMutation();
            },
        });
    }

    return {
        cancelVisitRequest: ({ confirm = true }: { confirm?: boolean } | undefined = {}) => {
            if (confirm) {
                return confirmCancelVisitRequest();
            } else {
                return doCancelVisitRequestMutation();
            }
        },
        loading,
        error,
    };
};

const CANCEL_VISIT_REQUEST_MUTATION = gql`
    mutation CancelVisitRequest($visitRequestId: UUID!) {
        cancelVisitRequest(visitRequestId: $visitRequestId) {
            id
            state
            workflowStep
            order {
                id
                numActiveOccurrences
            }
        }
    }
`;
